import React from 'react';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import EmptyBackground from './EmptyBackground';
import JournalStageBackground from './Journal';
import DefaultStageBackground from './Default';
import LiteratureStageBackground from './Literature';
import StatusStageBackground from './Status';
import CommissionStageBackground from './Commission';
const StageBackground = (props)=>{
    if (props.deviation.isBlocked) {
        return /*#__PURE__*/ React.createElement(EmptyBackground, null);
    }
    const deviationType = getDeviationType(props.deviation);
    switch(deviationType){
        case DeviationTypes.COMMISSION:
            return /*#__PURE__*/ React.createElement(CommissionStageBackground, props);
        case DeviationTypes.POLL:
            return /*#__PURE__*/ React.createElement(EmptyBackground, null);
        case DeviationTypes.STATUS:
            return /*#__PURE__*/ React.createElement(StatusStageBackground, props);
        case DeviationTypes.LITERATURE:
            return /*#__PURE__*/ React.createElement(LiteratureStageBackground, props);
        case DeviationTypes.TIER:
        case DeviationTypes.JOURNAL:
            return /*#__PURE__*/ React.createElement(JournalStageBackground, props);
        default:
            return /*#__PURE__*/ React.createElement(DefaultStageBackground, props);
    }
};
StageBackground.displayName = 'StageBackground';
export default StageBackground;

//# sourceMappingURL=StageBackground.js.map